/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IDobbiesDefaultMetatagsData } from './dobbies-default-metatags.data';
import { IDobbiesDefaultMetatagsProps } from './dobbies-default-metatags.props.autogenerated';

import { isNonceEnabled } from '@msdyn365-commerce/core-internal';

export interface IDobbiesDefaultMetatagsViewProps extends IDobbiesDefaultMetatagsProps<IDobbiesDefaultMetatagsData> {}

/**
 *
 * DobbiesDefaultMetatags component
 * @extends {React.PureComponent<IDobbiesDefaultMetatagsProps<IDobbiesDefaultMetatagsData>>}
 */
class DobbiesDefaultMetatags extends React.PureComponent<IDobbiesDefaultMetatagsProps<IDobbiesDefaultMetatagsData>> {
    // public render(): JSX.Element {
    //     try {
    //         console.log('Render Method is being Called of Dobbies default metatags');
    //     const { data, config } = this.props;
    //     const nonceToken = this.props.context && isNonceEnabled(this.props.context.request);
    //     let metaTagsHtml: string = '';
    //     let metaTags;
    //     const url = this.props.context.actionContext.requestContext.url.requestUrl.href;
    //     // const shouldAddMetatag = config.metaTagsDomains && config.metaTagsDomains.find(mtd => mtd === url || url.includes(mtd));
    //     // if (config.metaTags && shouldAddMetatag) {
    //     if (config.metaTags) {
    //         metaTags = nonceToken ? this._addNonceToInlineScript(config.metaTags, nonceToken) : config.metaTags;
    //         metaTagsHtml = metaTags && metaTags.join('\n');
    //     }
    //     // else if (data.metaTags && shouldAddMetatag) {
    //     // else if (data.metaTags) {
    //     //     metaTags = data.metaTags;
    //     //     let metaTagsText = metaTags.map(simpleText => simpleText.text);
    //     //     metaTagsText = nonceToken ? this._addNonceToInlineScript(metaTagsText, nonceToken) : metaTagsText;
    //     //     metaTagsHtml = metaTagsText && metaTagsText.join('\n');
    //     // }
    //     console.log('Meta Tags: ', metaTagsHtml);
    //     return React.createElement(SDK_FRAGMENT_NAME, { key: this.props.id, dangerouslySetInnerHTML: { __html: metaTagsHtml } });
    //     } catch (e) {
    //         console.log('Error Creating meta tag', e);
    //         return React.createElement(SDK_FRAGMENT_NAME, { key: this.props.id, dangerouslySetInnerHTML: { __html: "Error" } });
    //     }

    // }

    // private _addNonceToInlineScript(metaTags: string[], nonceToken: string): string[] {
    //     const inlineScripRegex = /<script((?:(?!src=).)*?)>(.*?)<\/script>/g;
    //     return metaTags
    //         .map(metaTag => {
    //             if (inlineScripRegex.test(metaTag)) {
    //                 return metaTag.replace(/<script/g, `<script nonce=${nonceToken}`);
    //             }
    //             return metaTag;
    //         })
    //         .filter(Boolean);
    // }

    public componentDidMount(): void {
        console.log('Did Mount Called on Default Meta Tags');
    }

    public render(): JSX.Element {
        const { config } = this.props;
        const nonceToken = this.props.context && isNonceEnabled(this.props.context.request);
        // let metaTagsHtml: string = '';
        const url = this.props.context.actionContext.requestContext.url.requestUrl.href;
        const shouldAddMetatag = config.metaTagsDomains && config.metaTagsDomains.find(mtd => mtd === url || url.includes(mtd));
        if (config.metaTags) {
            nonceToken ? this._addNonceToInlineScript(config.metaTags, nonceToken) : config.metaTags;
            // metaTagsHtml = metaTags && metaTags.join('\n');
        }
        // else if (data.metaTags) {
        //     metaTags = data.metaTags;
        //     let metaTagsText = metaTags.map(simpleText => simpleText.text);
        //     metaTagsText = nonceToken ? this._addNonceToInlineScript(metaTagsText, nonceToken) : metaTagsText;
        //     metaTagsHtml = metaTagsText && metaTagsText.join('\n');
        // }
        if (shouldAddMetatag) {
            return <meta name='robots' content='noindex' />;
        } else {
            return <></>;
        }

        // return React.createElement(SDK_FRAGMENT_NAME, { key: this.props.id, dangerouslySetInnerHTML: { __html: metaTagsHtml } });
    }

    private _addNonceToInlineScript(metaTags: string[], nonceToken: string): string[] {
        const inlineScripRegex = /<script((?:(?!src=).)*?)>(.*?)<\/script>/g;
        return metaTags
            .map(metaTag => {
                if (inlineScripRegex.test(metaTag)) {
                    return metaTag.replace(/<script/g, `<script nonce=${nonceToken}`);
                }
                return metaTag;
            })
            .filter(Boolean);
    }
}

export default DobbiesDefaultMetatags;
